import { useContext, useRef, useState } from "react";
import { LoginService } from "../../service/LoginService";
import { AppFunctions, AppFunctionsContext } from "../base/App";

interface Props {

	/** 閉じる時処理 */
	onClose: () => void,
};

export default function ReissuePassword(props: Props): JSX.Element {

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	/** アクセスID */
	const username = useRef<HTMLInputElement | null>(null);

	/** メールアドレス */
	const email = useRef<HTMLInputElement | null>(null);

	/**
	 * 再発行ボタンクリック時イベント
	 */
	const handleCommitClick = async () => {
		if (username.current!.value == '') {
			alert('アクセスIDを入力してください。');
			return;
		}
		if (email.current!.value == '') {
			alert('メールアドレスを入力してください。');
			return;
		}

		// パスワードを再発行する。
		const res = await new LoginService(appFunctions!).reissuePassword(username.current!.value, email.current!.value);
		if (res == true) {
			props.onClose();
		}
	};

	/**
	 * キャンセルボタンクリック時イベント
	 */
	const handleCancelClick = async () => {
		props.onClose();
	};

	// 描画する
	return (
		<div className="dialog">
			<div className="dialog-contents">
				<h4>パスワード再発行</h4>
				<hr />
				<div className="control-group">
					<div>
						<table width="100%" className="hyosearch">
							<tbody>
								<tr>
									<td scope="row">検索用アクセスID</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="username" size={35} ref={username} />
										</div>
									</td>
								</tr>
								<tr>
									<td scope="row">メールアドレス</td>
									<td scope="row" colSpan={3}>
										<div>
											<input type="text" name="email" size={35} ref={email} />
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<hr />
				<div className="control-group">
					<div className="controls">
						<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleCommitClick}>再発行</button>
						&nbsp;
						<button className="btn btn-default btn-secondary pull-center" type="button" onClick={handleCancelClick}>キャンセル</button>
					</div>
				</div>
			</div>
		</div>
	);
}